import moment from "moment";

const RESTRICTED_STATES = new Set([
  "EXPIRED_FINANCE_ONLY",
  "NEEDS_REVIEW",
]);

export const isServerAccessPolicyEnforced = (user) =>
  user?.companyAccess?.enforcementEnabled === true;

export const isCompanyFinanceOnly = (user) => {
  if (!user?.company || user.company.id === 1) return false;

  if (isServerAccessPolicyEnforced(user)) {
    return RESTRICTED_STATES.has(user.companyAccess.state);
  }

  // Compatibility only while BILLING_ACCESS_POLICY_ENABLED is OFF.
  const dueDate = user.company.dueDate;
  if (!dueDate) return false;
  return moment().startOf("day").isAfter(moment(dueDate).startOf("day"), "day");
};

export const getDaysUntilDueDate = (user) => {
  if (isServerAccessPolicyEnforced(user)) {
    return user?.companyAccess?.daysUntilDueDate;
  }
  if (!user?.company?.dueDate) return null;
  return moment(user.company.dueDate)
    .startOf("day")
    .diff(moment().startOf("day"), "days");
};
